//
//
//
//
//
//
//
//
//
//
//
//
//
//

import customer from '@/customer'

export default {
  props: {
    blankStyle: {
      type: String,
      default: '100vh'
    },
    text: {
      type: String,
      default: '什么都没有~'
    },
    text2: {
      type: String,
      default: ''
    },
    btn: {
      type: String,
      default: ''
    },
    btnShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    blankImage () {
      return customer.assets.blankImage || '/static/images/noData.png'
    },
    blankImageStyle () {
      return customer.assets.blankImageStyle || {
        width: '110px',
        height: '110px'
      }
    }
  },
  components: {},
  created() {
  },
  methods: {
  	btnClick () {
  		this.$emit('btnClick')
  	}
  }
};



// WEBPACK FOOTER //
// ./src/components/cmBlank.vue